// extracted by mini-css-extract-plugin
module.exports = {"rpSpinner":"ResortPassAnimation_rpSpinner__kiuIc","lottie":"ResortPassAnimation_lottie__P042U"};